export default "__VITE_ASSET__PwyUP6yZ__"